import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';

import { Title } from '@angular/platform-browser';

import { AuthService } from '../auth.service';
import { CrudService } from './crud.service';
import { environment } from '../../environments/environment';

import { Mensaje } from '../mensaje';
import { CurrencyPipe } from "@angular/common";

import { NumeroLetraPipe } from '../pipes/numero-letra.pipe';

import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
//import { Select2OptionData } from "ng-Select2";
import { NgSelect2Module } from 'ng-select2';
import { Options } from "select2";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import { saveAs } from "file-saver";

@Component({
  selector: "app-formulario",
  template: `
    <simple-notifications [options]="options"></simple-notifications>
    <div class="modal" id="confirmarEliminar">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
          <button
            class="delete"
            (click)="cancelarModal('confirmarEliminar')"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <h1>¿Esta seguro de eliminar el elemento?</h1>
            <p>Ya no se podra recuperar la información</p>
          </div>
        </section>
        <footer class="modal-card-foot">
          <a
            class="button is-success"
            (click)="borrar(borrarItem)"
            [ngClass]="{ 'is-loading': borrarCargando }"
            >Continuar</a
          >
          <a class="button" (click)="cancelarModal('confirmarEliminar')"
            >Cancelar</a
          >
        </footer>
      </div>
    </div>

    <div class="modal" id="confirmarEliminar2">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
          <button
            class="delete"
            (click)="cancelarModal('confirmarEliminar2')"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <h1>¿Esta seguro de eliminar el elemento?</h1>
            <p>Ya no se podra recuperar la información</p>
          </div>
        </section>
        <footer class="modal-card-foot">
          <a
            class="button is-success"
            (click)="borrarDos(borrarItem)"
            [ngClass]="{ 'is-loading': borrarCargando }"
            >Continuar</a
          >
          <a class="button" (click)="cancelarModal('confirmarEliminar2')"
            >Cancelar</a
          >
        </footer>
      </div>
    </div>


    <div class="modal" id="confirmarEliminarFoto">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title"><i class="fa fa-warning"></i> Alerta</p>
          <button
            class="delete"
            (click)="cancelarModal('confirmarEliminarFoto')"
          ></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <h1>¿Esta seguro de eliminar la imagen?</h1>
            <p>Recuerde guardar los cambios para eliminarlo o cambiarlo</p>
          </div>
        </section>
        <footer class="modal-card-foot">
          <a
            class="button is-success"
            (click)="eliminarImagen(borrarItemFoto, borrarItemCarpeta)"
            [ngClass]="{ 'is-loading': borrarCargando }"
            >Continuar</a
          >
          <a class="button" (click)="cancelarModal('confirmarEliminarFoto')"
            >Cancelar</a
          >
        </footer>
      </div>
    </div>
  `
})
export class FormularioComponent implements OnInit {
  borrarCargando: boolean = false;
  id: string;
  moduloTitulo: string;
  datosCargados: boolean = true;
  guardado: boolean = false;
  cargando: boolean = false;
  cambiarPassword: boolean = false;

  public optionSelect: Options;
  public selected: string;

  derecha: any[] = [];
  izquierda: any[] = [];

  API_PATH = environment.API_PATH;
  CFDI_PATH = environment.CFDI_PATH;
  subir: any = [];

  permisos = JSON.parse(localStorage.getItem("permisos"));
  configuracion = JSON.parse(localStorage.getItem("configuracion"));

  intento1 = 0;
  intento2 = 0;
  intento3 = 0;
  // Crear la variable que mustra las notificaciones
  mensajeResponse: Mensaje = new Mensaje();
  tamano = document.body.clientHeight;
  // Varaibles de entrada se pasan los valores desde la vista
  @Input() URL: string;
  @Input() titulo: string;
  @Input() dato: FormGroup;

  /**
   * Este método inicializa la carga de las dependencias
   * que se necesitan para el funcionamiento del modulo
   */
  constructor(
    private router: Router,
    private title: Title,
    private authService: AuthService,
    private route: ActivatedRoute,
    private location: Location,
    private crudService: CrudService,
    private fb: FormBuilder,
    private notificacion: NotificationsService
  ) { }
  /**
   * Este método se dispara al iniciar la carga de la vista asociada
   * @return void
   */
  ngOnInit() {
    this.title.setTitle(this.titulo);

    if (typeof localStorage.getItem(this.URL) == 'object')
      this[this.URL] = JSON.parse(localStorage.getItem(this.URL));
    else
      this[this.URL] = localStorage.getItem(this.URL);

    this.route.params.subscribe(params => {
      this.id = params["id"]; //  Se puede agregar un simbolo + antes de la variable params para volverlo number

      if (this.id) {
        if (this.id == "yo") {
          this.id = JSON.parse(localStorage.getItem("usuario")).id;
        }
        if (!document.getElementById("cargar_datos_dinamicos"))
          this.cargarDatos();
      }
    });

    this.moduloTitulo = this.id ? "Modificar" : "Nuevo";

    this.optionSelect = {
      width: "100%",
      language: {
        noResults: function () {
          return "No hay resultado";
        },
        searching: function () {
          return "Buscando ...";
        }
      }
    };
  }

  /**
   * Este método envia es intermediario y determina si un elemento es nuevo
   * o solo se esta editando
   * @return void
   */
  enviar(regresar: boolean = true, reset_form: boolean = false) {
    if (this.id) {
      this.actualizarDatos();
    } else {
      this.guardarDatos(regresar, reset_form);
    }
  }

  /**
   * Este método envia los datos para agregar un elemento
   * @return void
   */
  guardarDatos(regresar, reset_form) {
    this.cargando = true;
    this.guardado = false;
    let json = this.dato.getRawValue();

    this.crudService.crear(json, this.URL).subscribe(
      resultado => {
        this.guardado = true;
        this.cargando = false;
        if (resultado.status == 200 || resultado.status == 201 ){
          if(document.getElementById('despues_de_guardar'))
            document.getElementById('despues_de_guardar')?.click();
          this.quitar_elemento_cola();
          if (regresar) {
            this.location.back();
          }
          if (reset_form) {
            this.reset_form();
          }

          // console.log(resultado)
        }
        else {
          this.mensajeResponse.texto = 'No se guardado los cambios."';
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      },
      error => {
        this.cargando = false;
        this.guardado = false;
        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = "error";
        this.mensaje(3);

        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
          }
          //  Problema de validación
          if (error.status == 409) {
            this.mensajeResponse.texto =
              "Por favor verfique los campos marcados en rojo.";
            this.mensajeResponse.clase = "warning";
            this.mensaje(8);
            for (let input in e.error) {
              //  Iteramos todos los errores
              for (let i in e.error[input]) {
                this.mensajeResponse.titulo = input;
                this.mensajeResponse.texto = e.error[input][i];
                this.mensajeResponse.clase = "error";
                this.mensaje(3);
              }
            }
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 2";
          }
        }
      }
    );
  }
  /**
   * Este método envia los datos para actualizar un elemento con el id
   * que se envia por la url
   * @return void
   */
  actualizarDatos() {
    this.cargando = true;
    let dato = this.dato.getRawValue();
    if (!this.cambiarPassword) {
      delete dato.cambiarPassword;
    }
    this.crudService.editar(this.id, dato, this.URL).subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status == 200 || resultado.status == 201) {
          if (document.getElementById('despues_de_guardar'))
            document.getElementById('despues_de_guardar')?.click();
          this.quitar_elemento_cola();
          this.mensajeResponse.texto = 'Se han guardado los cambios."';
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "success";
          this.mensaje(2);
        }else{
          this.mensajeResponse.texto = 'No se guardado los cambios."';
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
      },
      error => {
        this.cargando = false;

        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = "alert";
        this.mensaje(2);
        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
            this.mensajeResponse.clase = "error";
            this.mensaje(2);
          }
          //  Problema de validación
          if (error.status == 409) {
            this.mensajeResponse.texto =
              "Por favor verfique los campos marcados en rojo.";
            this.mensajeResponse.clase = "error";
            this.mensaje(8);
            for (let input in e.error) {
              //  Iteramos todos los errores
              for (let i in e.error[input]) {
                this.mensajeResponse.titulo = input;
                this.mensajeResponse.texto = e.error[input][i];
                this.mensajeResponse.clase = "error";
                this.mensaje(3);
              }
            }
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 3";
          }
          this.mensajeResponse.clase = "error";
          this.mensaje(2);
        }
      }
    );
  }

  /**
   * Este método limpia el formulario reactivo
   * @return true
   */
  reset_form() {
    try {
      this.dato.reset();
      for (let item in this.dato.controls) {
        const ctrl = <FormArray>this.dato.controls[item];
        if (ctrl.controls) {
          if (typeof ctrl.controls.length == "number") {
            while (ctrl.length) {
              ctrl.removeAt(ctrl.length - 1);
            }
            ctrl.reset();
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
    return true;
  }

  /**
   * Este método es recursivo y recorre todo el formulario reactivo para crear los nodos que son de tipo array y agregar su respectivo valor
   * @param resultado json con los datos del objecto resultado de la consulta a la base de datos
   * @param data formulario reactivo donde se guardaran los valores resultantes
   * @return data
   */
  cargarDatosRecursivoArray(resultado, data) {
    try {
      if (resultado.length > 0) {
        resultado.forEach((element, clave) => {
          if (Array.isArray(element)) {
            try {
              if (!data.controls.hasOwnProperty(clave)) {
                data.controls[clave] = new FormArray([]);
              }
              let otro = <FormArray>data.controls[clave];
              if (element.length > 0) {
                this.cargarDatosRecursivoArray(element, otro);
              }
            } catch (e) {
              console.log(4, clave, e);
            }
          } else {
            try {
              if (typeof resultado[clave] == "object" && resultado[clave]) {
                if (!data.controls[clave]) {
                  data.controls[clave] = new FormGroup({});
                }
                let otro = <FormGroup>data.controls[clave];
                otro.patchValue(this.cargarDatosRecursivoObject(element, otro));
              } else if (
                typeof resultado[clave] == "string" ||
                typeof resultado[clave] == "number" ||
                typeof resultado[clave] == "boolean" ||
                resultado[clave] == null
              ) {
                data.addControl(clave, new FormControl(resultado[clave]));
              } else {
                console.log("por que llegue aca");
              }
            } catch (e) {
              console.log(3, clave, e);
            }
          }
        });
      }
      return data;
    } catch (e) {
      console.log("arr", e);
    }
  }

  /**
   * Este método es recursivo y recorre todo el formulario reactivo para crear los nodos que son de tipo object y agregar su respectivo valor
   * @param resultado json con los datos del objecto resultado de la consulta a la base de datos
   * @param data formulario reactivo donde se guardaran los valores resultantes
   * @return data
   */

  cargarDatosRecursivoObject(resultado, data) {
    try {
      for (let key in resultado) {
        if (Array.isArray(resultado[key])) {
          try {
            if (!data.controls.hasOwnProperty(key)) {
              data.addControl(key, new FormArray([]));
            }
            if (resultado[key].length > 0) {
              let control = <FormArray>data.controls[key];
              this.cargarDatosRecursivoArray(resultado[key], control);
            }
          } catch (e) {
            console.log(2, key, e);
          }
        } else {
          try {
            if (!data.controls.hasOwnProperty(key)) {
              if (typeof resultado[key] == "object" && resultado[key]) {
                data.addControl(key, new FormGroup({}));
              } else if (
                typeof resultado[key] == "string" ||
                typeof resultado[key] == "number" ||
                typeof resultado[key] == "boolean" ||
                resultado[key] == null
              ) {
                data.addControl(key, new FormControl(resultado[key]));
              } else {
                console.log("por que llegue aca");
              }
            }

            const control = <FormGroup>data.controls[key];
            if (typeof resultado[key] == "object" && resultado[key]) {
              control.patchValue(
                this.cargarDatosRecursivoObject(resultado[key], control)
              );
            } else {
              if (resultado[key]) {
                control.patchValue(resultado[key]);
              } else if (resultado[key] == 0){
                control.patchValue(resultado[key]);
              }
            }
          } catch (e) {
            console.log(1, key, e);
          }
        }
      }
    } catch (e) {
      console.log("obj", e);
    }
    return data;
  }

  /**
   * Este método carga los datos de un elemento de la api con el id que se pase por la url
   * en la api, abre una ventana modal para confirmar la acción
   * @return void
   */
  cargarDatos() {
    this.tamano = document.body.clientHeight;
    if (this.reset_form()) {
      try {
        this.cargando = true;

        this.crudService.ver(this.id, this.URL).subscribe(
          resultado => {
            // validar todos los key que tengan el array
            if (Array.isArray(resultado.data)) {
              this.dato.patchValue(
                this.cargarDatosRecursivoArray(resultado.data, this.dato)
              );
            } else {
              this.dato.patchValue(
                this.cargarDatosRecursivoObject(resultado.data, this.dato)
              );
            }
            for(let key in resultado){
              if (key != "data") {
                this[key] = resultado[key];
              }
            }
            this.dato.updateValueAndValidity();
            if (document.getElementById("catalogos")) {
              document.getElementById("catalogos")?.click();
            }
            if (document.getElementById("recargar")) {
              document.getElementById("recargar")?.click();
            }
            this.cargando = false;
            this.datosCargados = true;

            this.mensajeResponse.titulo = "Modificar";
            this.mensajeResponse.texto = "Los datos se cargaron";
            this.mensajeResponse.clase = "success";
            this.mensaje(2);
            this.intento3 = 0;
          },
          error => {
            this.cargando = false;
            this.datosCargados = false;

            this.mensajeResponse = new Mensaje(true);
            this.mensajeResponse = new Mensaje(true);
            this.mensajeResponse.mostrar;

            try {
              let e = error.json();
              if (error.status == 401) {
                this.mensajeResponse.texto =
                  "No tiene permiso para hacer esta operación.";
                this.mensajeResponse.clase = "success";
                this.mensaje(2);
              } else {
                setTimeout(() => {
                  if (this.intento3 < 1) {
                    this.cargarDatos();
                    this.intento3++;
                  }
                }, 200);
              }
            } catch (e) {
              setTimeout(() => {
                if (this.intento3 < 1) {
                  this.cargarDatos();
                  this.intento3++;
                }
              }, 200);
            }
          }
        );
      } catch (e) {
        console.log(0, e);
      }
    }
  }

  // abre una modal para confirmar la eliminacion
  borrarItem = "";

  /**
   * Este método es intermediario para la eliminación de un elemento
   * en la api, abre una ventana modal para confirmar la acción
   * @param item contiene el valor del elemento a eliminar
   * @param index  indica la posicion del elemento en la lista cargada
   * @return void
   */
  eliminar(item: any): void {
    this.borrarItem = item;
    document.getElementById("confirmarEliminar").classList.add("is-active");
  }

  eliminarDos(item: any): void {
    this.borrarItem = item;
    document.getElementById("confirmarEliminar2").classList.add("is-active");
  }

  /**
   * Este método abre una modal
   * @param id identificador del elemento de la modal
   * @return void
   */
  abrirModal(id) {
    document.getElementById(id).classList.add("is-active");
  }

  /**
   * Este método cierra el modal de la de confirmación de eleimnación
   * @return void
   */
  cancelarModal(id: string = "confirmarEliminar") {
    document.getElementById(id).classList.remove("is-active");
  }
  cancelarModalDos(id: string = "confirmarEliminar2") {
    document.getElementById(id).classList.remove("is-active");
  }

  /**
   * Este método se encarga de la eliminacion de un elemento
   * en la api
   * @param item contiene el valod del elemento a eliminar
   * @param index  indica la posicion del elemento en la lista cargada
   * @return void
   */
  borrar(item: any): void {
    console.log('Funcion Borrar');
    
    console.log(item);

    console.log('url Borrar');
    
    console.log(this.URL);
    this.borrarCargando = true;
    this.crudService.eliminar(item, this.URL).subscribe(
      data => {
        this.borrarCargando = false;

        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.texto = "Se eliminó el elemento de la lista.";
        this.mensajeResponse.clase = "success";
        this.mensaje(2);

        this.cancelarModal();

        this.regresar();
      },
      error => {
        this.borrarCargando = false;

        this.mensajeResponse.mostrar = true;
        this.cancelarModal();

        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
            this.mensajeResponse.clase = "danger";
            this.mensaje(2);
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 5";
          }
          this.mensajeResponse.clase = "danger";
          this.mensaje(2);
        }
      }
    );
  }

  borrarDos(item: any): void {
    // console.log('Funcion Borrar');
    
    // console.log(item);

    // console.log('url Borrar');
    
    // console.log(this.URL);
    this.borrarCargando = true;
    this.crudService.eliminar(item, 'repeticion').subscribe(
      data => {
        this.borrarCargando = false;

        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.texto = "Se eliminó el elemento de la lista.";
        this.mensajeResponse.clase = "success";
        this.mensaje(2);

        this.cancelarModalDos();
        document.getElementById("cargar_datos_actualizar").click();
        // this.regresar();
      },
      error => {
        this.borrarCargando = false;

        this.mensajeResponse.mostrar = true;
        this.cancelarModalDos();

        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
            this.mensajeResponse.clase = "danger";
            this.mensaje(2);
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 5";
          }
          this.mensajeResponse.clase = "danger";
          this.mensaje(2);
        }
      }
    );
  }


  /**
   * Este metodo se encarga de cargar los datos de un catalogo para crear un select, grupos de radios o check
   * @param item nombre del modelo donde se guardaron los resultados
   * @param url  ruta de la pai donde se obtienen los valores
   * @return void
   */
  parametros = {
    pagina: 0,
    limite: 0
  };
  catalogo: any[] = [];
  roles: any[] = [];
  cargarCatalogo(item, url, id: string = "", cargando = "") {
    this.cargando = true;
    this[cargando] = true;
    this[item] = [];

    this.parametros.pagina = 0;
    this.parametros.limite = 0;
    this.crudService.lista(this.parametros, url).subscribe(
      resultado => {
        if (Array.isArray(resultado.data)) {
          resultado.data.forEach(element => {
            if (!element.text) {
              element.text = element.nombre;
            }
          });
        }
        this[item] = resultado.data;
        this.cargando = false;
        if (resultado.length == 0) {
          this.mensajeResponse.titulo = item;
          this.mensajeResponse.texto = `Esta vacio, póngase en contacto con un administrador.`;
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "warning";
          this.mensaje(3);
        }
        this[cargando] = false;
        if (id != "") {
          setTimeout(() => {
            document.getElementById(id)?.click();
          }, 300);
        }
        this.intento1 = 0;
      },
      error => {
        this[cargando] = false;
        this.mensajeResponse = new Mensaje(true);
        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;
        
        try {
          let e = error.json();

          if (error.status == 401) {
            this.mensajeResponse.texto = "No tiene permiso para ver los roles.";
          } else {
            setTimeout(() => {
              if (this.intento1 < 1) {
                this.cargarCatalogo(item, url, id);
                this.intento1++;
              }
            }, 200);
          }
        } catch (e) {
          setTimeout(() => {
            if (this.intento1 < 1) {
              this.cargarCatalogo(item, url, id);
              this.intento1++;
            }
          }, 200);
        }
      }
    );
  }

  /**
   * Este metodo se encarga de cargar los datos de un catalogo que depende de otro
   * @param url  ruta de la pai donde se obtienen los valores
   * @param item nombre del modelo donde se guardaron los resultados
   * @param id  id del catalogo del que depende
   * @return void
   */
   catalogoDependiente = function (url, item, id, i = -1, cargando = '') {
    let operador = '?';
    if (url.indexOf('?') > -1) {
        operador = '&';
    }
    this[cargando] = true;

    this.parametros.pagina = 0;
    this.parametros.limite = 0;

    this.crudService
        .lista(this.parametros, url + operador + 'id=' + id)
        .subscribe(
            (resultado) => {
                resultado.data.forEach((element) => {
                    if (!element.text) {
                        element.text = element.nombre;
                    }
                });
                if (i > -1) {
                    this[item][i] = resultado.data;
                } else {
                    this[item] = resultado.data;
                }
                if (resultado.length === 0) {
                    this.mensajeResponse.titulo = item;
                    this.mensajeResponse.texto = this.localizationService.translate('SIN_RESULTADO');
                    this.mensajeResponse.mostrar = true;
                    this.mensajeResponse.clase = 'warning';
                    this.mensaje(3);
                }
                this[cargando] = false;
                this.cargarDatosCatalogo = false;
                this.intento2 = 0;
            },
            (error) => {
                this.ocurrio_error_mostrar(error);
                this.cargarDatosCatalogo = false;
                this[cargando] = false;
            }
        );
};

  /**
   * Este método regresa a una pagina anterior
   * @return void
   */
  regresar() {
    this.location.back();
  }

  /**
   * Este método agrega un id de un catalogo a un array
   * ejemplo <code>(click)="ctrl.addInFormArray(val.id, ctrl.dato.controls.permisos, true)"</code>
   * @param valor valor a agregar al array de datos
   * @param modelo  array de datos
   * @param key nombre de la clave para guardar temporal
   * @param esmodelo Bandera que determina si el modelo es un formGroup
   * @return void
   */
  modelo = [];
  addInFormArray(valor, modelo, key, esmodelo: boolean = false) {
    if (!this.modelo[key]) {
      this.modelo[key] = modelo.value;
    }
    let i = this.modelo[key].indexOf(valor);
    let i2 = -1;
    if (typeof this.modelo[key] == "object") {
      i2 = JSON.stringify(this.modelo[key]).indexOf(JSON.stringify(valor));
    }
    if (i > -1) {
      this.modelo[key].splice(i, 1);
    } else if (i2 > -1) {
      this.modelo[key].splice(i2, 1);
    } else {
      this.modelo[key].push(valor);
    }

    if (!esmodelo) modelo = this.modelo[key];
    else {
      modelo = this.fb.group({});
      modelo.patchValue(this.modelo[key]);
    }
  }

  todosSeleccionados: any = [];
  /**
   * Este método agrega los ids de un elemento al listado de un modelo
   * ejemplo <code>(click)="ctrl.seleccionarTodos('admin', arrayDatos, ctrl.dato.controls.permisos, true)"</code>
   * @param clave nombre para identificar en caso de que sean muchos
   * @param valores Valores a agregar en el modelo
   * @param modelo Nombre del modelo
   * @param esmodelo Bandera que determina si el modelo es un formGroup
   * @return void
   */
  seleccionarTodos(clave, valores, modelo, esmodelo: boolean = false) {
    if (!this.todosSeleccionados[clave]) {
      this.todosSeleccionados[clave] = false;
    }
    this.todosSeleccionados[clave] = !this.todosSeleccionados[clave];
    let i = 0;
    let temp;
    if (!esmodelo) {
      this.modelo[clave] = [];
    } else {
      this.modelo[clave] = modelo.value;
    }
    if (esmodelo) {
      temp = modelo.value;
    }
    for (let item of valores) {
      if (this.todosSeleccionados[clave]) {
        this.modelo[clave].push(item.id);
      } else {
        if (esmodelo) {
          temp.splice(modelo.value.indexOf(item.id), 1);
        } else {
          modelo.splice(this.modelo[clave].indexOf(item.id), 1);
        }
      }
    }
    if (!esmodelo) {
      modelo.push(this.modelo[clave]);
    } else {
      if (this.todosSeleccionados[clave]) {
        modelo.patchValue(this.modelo[clave]);
      } else {
        modelo.patchValue(temp);
      }
    }
  }

  /**
   * Este método genera un array de datos a mover de izquierda a derecha o viseversa en el control mover
   * ejemplo <code>(click)="ctrl.seleccionarTodosMover('derecha',ctrl.derecha[0], ctrl.dato.controls.almacen_tipos_movimientos.controls)"</code>
   * @param key  Posicion izquierda-derecha del movimiento de los datos
   * @param clave objetoque contiene la posicion izquierda-derecha del movimiento de los datos
   * @param modelo  modelo de donde se va a seleccionar los elementos a mover
   * @return void
   */
  seleccionarTodosMover(key, clave, modelo) {
    if (!this.todosSeleccionados[key]) {
      this.todosSeleccionados[key] = false;
    }
    this.todosSeleccionados[key] = !this.todosSeleccionados[key];

    for (let item of modelo) {
      if (this.todosSeleccionados[key]) {
        clave.push(item);
      } else {
        clave.splice(clave.indexOf(item), 1);
      }
    }
  }

  /**
   * Este método agrega un objeto a un array de elementos para mover
   * ejemplo <code>(click)="ctrl.agregarMover('derecha', ctrl.dato.controls.almacen_tipos_movimientos.controls, item)"</code>
   * @param clave Posicion izquierda-derecha del movimiento de los datos
   * @param modelo  modelo que corresponde al array a agregar los elementos
   * @param valor valor a agregar al array
   * @return void
   */
  agregarMover(clave, modelo, valor) {
    let i = clave.indexOf(valor);
    if (i > -1) {
      clave.splice(i, 1);
    } else {
      clave.push(valor);
    }
  }

  /**
   * Este método verifica que el modelo de mover datos no aparezca en la lista de seleccion si existe quitarlo de izquierda
   * ejemplo
   * <code>(click)="ctrl.initMover(ctrl.dato.controls.almacen_tipos_movimientos.controls, ctrl.tipos_movimientos)"</code>
   * @param toModelo  modelo que corresponde al array a agregar los elementos
   * @param ofModelo modelo de donde se quitan los valores
   * @return void
   */
  initMover(toModelo, ofModelo, campo: string = "id") {
    for (let item of toModelo) {
      let i = 0;
      for (let val of ofModelo) {
        if (item.value[campo] == val[campo]) {
          ofModelo.splice(i, 1);
        }
        i++;
      }
    }
  }
  /**
   * Este método agrega un objeto a un array de elementos para mover
   * ejemplo
   * <code>(click)="ctrl.iniciarMover('derecha', ctrl.derecha[0], ctrl.tipos_movimientos, ctrl.dato.controls.almacen_tipos_movimientos, false)"</code>
   * <code>(click)="ctrl.iniciarMover('izquierda', ctrl.izquierda[0], ctrl.dato.controls.almacen_tipos_movimientos, ctrl.tipos_movimientos, true)"</code>
   * @param key Posicion izquierda-derecha del movimiento de los datos
   * @param clave objetoque contiene la posicion izquierda-derecha del movimiento de los datos
   * @param toModelo  modelo que corresponde al array a agregar los elementos
   * @param ofModelo modelo de donde se quitan los valores
   * @param esmodelo Bandera que determina si el modelo es un formGroup
   * @return void
   */
  iniciarMover(
    key,
    clave,
    toModelo,
    ofModelo,
    esmodelo: boolean = false,
    campo: string = "id"
  ) {
    for (let item of clave) {
      if (esmodelo) {
        const toModel = <FormArray>toModelo;
        toModel.push(this.fb.group(item));
        let i = 0;
        for (let val of ofModelo) {
          if (item[campo] == val[campo]) {
            ofModelo.splice(i, 1);
          }
          i++;
        }
      } else {
        toModelo.push(item.value);
        let i = 0;
        ofModelo.controls.forEach(val => {
          if (item.value[campo] == val.value[campo]) {
            ofModelo.removeAt(i);
          }
          i++;
        });
      }
    }
    clave = [];
    if (this.todosSeleccionados[key]) {
      ofModelo = [];
    }
    this.todosSeleccionados[key] = false;
  }

  /**
   * Este método genera una cadena de longitud determinada y la agrega a un modelo
   * ejemplo <code>(click)="ctrl.generarCadenaRandom(ctrl.dato.controls.id, 32, true)"</code>
   * @param modelo  Nombre del modelo donde se guarda la cadena
   * @param ctrl.tamano  longitud de la cadena
   * @param esmodelo Bandera que determina si el modelo es un formGroup
   * @return void
   */
  generarCadenaRandom(modelo, tamano, esmodelo: boolean = false) {
    let cadena = "";
    let random = Math.floor(Math.random() * (9999 * tamano - 1111)) + tamano;

    for (let i = 0; i < tamano; i++) {
      random +=
        "" + Math.floor(Math.random() * (9999 * tamano - 1111)) + tamano;
    }
    let tiempo = Math.round(new Date().getTime() / 1000);

    cadena = "" + tiempo + random;
    cadena = btoa(cadena);
    cadena = cadena.substr(0, cadena.length - 3);
    cadena = cadena.substr(Math.floor(Math.random() * (100 - 10)) + 1, tamano);
    if (!esmodelo) {
      modelo = cadena;
    } else {
      modelo.patchValue(cadena);
    }
  }

  /**
   * Este método selecciona un item y lo pasa al modelo del autocomplete para no mandar el objeto si no se requiere y mandar unicamente el valor
   * ejemplo <code>(valueChanged)="ctrl.select_item_autocomplete(ctrl.dato.controls.clues, 'clues', $event, true)"</code>
   * @param modelo Nombre del modelo donde se guarda el dato obtenido
   * @param item nombre del item a extraer del objeto
   * @param datos objeto donde se busca el elemento para su extraccion
   * @param esmodelo Bandera que determina si el modelo es un formGroup
   * @return void
   */
  select_item_autocomplete(modelo, item, datos, esmodelo: boolean = false) {
    if (!esmodelo) {
      modelo = datos[item];
    } else {
      modelo.patchValue(datos[item]);
    }
  }

  /**
   * Este método agrega un formgrupo a un formarray, para crear un formulario dinamico
   * ejemplo <code>(click)="ctrl.agregar_form_array(ctrl.dato.controls.almacen_tipos_movimientos, form_almacen_tipos_movimientos)"</code>
   * @param modelo Nombre del modelo donde se guarda el dato obtenido
   * @param formulario Nombre del modelo donde se guarda el dato obtenido
   * @return void
   */
  agregar_form_array(modelo: FormArray, formulario) {
    (<FormArray>modelo).push(this.fb.group(formulario));
  }

  /**
   * Este método quita un formgrupo a un formarray, para crear un formulario dinamico
   * ejemplo <code>(click)="ctrl.quitar_form_array(ctrl.dato.controls.almacen_tipos_movimientos, i)"</code>
   * @param modelo Nombre del modelo donde se guarda el dato obtenido
   * @param i Posicion del elemento a eliminar
   * @return void
   */
  quitar_form_array(modelo, i: number) {
    modelo.removeAt(i);
  }

  /**
   * Este método quita un formgrupo a un formarray, para crear un formulario dinamico
   * ejemplo <code>(click)="ctrl.limpiar_form_array(ctrl.dato.controls.almacen_tipos_movimientos)"</code>
   * @param modelo Nombre del modelo donde se guarda el dato obtenido
   * @param i Posicion del elemento a eliminar
   * @return void
   */
  limpiar_form_array(modelo) {
    while (modelo.controls.length) {
      modelo.removeAt(modelo.controls.length - 1);
    }
  }

  /**
   * Este método muestra el confirm para eliminar una imagen de un modelo <input type="button" (change)="borrarImagen($event, 'modelo', 'persona')">
   * @param evt Evento change del campo file
   * @param modelo Modelo donde guardaremos la cadena en base64 de la imagen
   * @param carpeta carpeta donde se encuentra alojado la imagen
   * @return void
   */
  borrarItemFoto;
  borrarItemCarpeta;
  borrarImagen(evt, modelo, carpeta, index): void {
    this.borrarItemFoto = modelo;
    this.borrarItemCarpeta = carpeta;
    document.getElementById("confirmarEliminarFoto").classList.add("is-active");
  }

  /**
   * Este método borra una imagen de un modelo
   * @param evt Evento change del campo file
   * @param modelo Modelo donde guardaremos la cadena en base64 de la imagen
   * @param multiple bandera que determina si el campo es multiple
   * @return void
   */
  eliminarImagen(modelo, carpeta) {
    let foto = modelo.value;

    let json = this.fb.group({ file: foto, ruta: carpeta }).getRawValue();
    this.crudService.crear(json, "subir-archivo/eliminar").subscribe(
      resultado => {
        this.cargando = false;
        modelo.patchValue("");
        this.cancelarModal("confirmarEliminarFoto");
      },
      error => {
        this.cargando = false;

        this.mensajeResponse.texto = "No especificado.";
        this.mensajeResponse.mostrar = true;
        this.mensajeResponse.clase = "error";
        this.mensaje(3);

        try {
          let e = error.json();
          if (error.status == 401) {
            this.mensajeResponse.texto =
              "No tiene permiso para hacer esta operación.";
          }
        } catch (e) {
          if (error.status == 500) {
            this.mensajeResponse.texto = "500 (Error interno del servidor)";
          } else {
            this.mensajeResponse.texto =
              "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 2";
          }
        }
      }
    );
  }
  error_archivo = false;
  /**
   * Este método selecciona una imagen de un campo file <input type="file" (change)="seleccionarImagenBase64($event, 'modelo')">
   * @param evt Evento change del campo file
   * @param modelo Modelo donde guardaremos la cadena en base64 de la imagen
   * @param multiple bandera que determina si el campo es multiple
   * @return void
   */
  seleccionarImagenBase64(
    evt,
    modelo,
    multiple: boolean = false,
    index: number = 0
  ) {
    let files = evt.target.files;
    let esto = this;
    esto.error_archivo = false;
    if (!multiple) {
      let file = files[0];
      if (files && file) {
        let reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = (function (theFile) {
          return function (e) {
            try {
              modelo.patchValue(btoa(e.target[0].result));
            } catch (ex) {
              esto.error_archivo = true;
            }
          };
        })(file);
      }
    } else {
      let objeto = [];
      for (let i = 0, f; (f = files[i]); i++) {
        let reader = new FileReader();
        reader.readAsBinaryString(f);
        reader.onload = (function (theFile) {
          return function (e) {
            try {
              objeto.push(btoa(e.target[0].result));
            } catch (ex) {
              esto.error_archivo = true;
            }
          };
        })(f);
      }
      modelo.patchValue(objeto);
    }
    this.subir[index] = true;
  }
  error_json = false;
  /**
   * Este método selecciona un archivo txt con un json para subirlo <input type="file" (change)="seleccionarJson($event, 'modelo')">
   * @param evt Evento change del campo file
   * @param modelo Modelo donde guardaremos la cadena en base64 de la imagen
   * @return void
   */
  convertirJson(evt, modelo, mostrar) {
    modelo.patchValue("");
    this.error_json = false;
    let files = evt.target.files;
    let file = files[0];
    let esto = this;
    if (files && file) {
      let json = "";
      let reader = new FileReader();
      reader.readAsBinaryString(file);
      reader.onload = (function (theFile) {
        return function (e) {
          try {
            json = JSON.parse(e.target[0].result);
            modelo.patchValue(json);
          } catch (ex) {
            esto.error_json = true;
          }
        };
      })(file);
    }
  }

  // mostrar notificaciones configuracion default, posicion abajo izquierda, tiempo 2 segundos
  public options = {
    position: ["bottom", "left"],
    timeOut: 2000,
    lastOnBottom: true
  };

  /**
   * Este método selecciona un valor de un select2 y lo pasa al modelo
   * @param valor valor del options del selec seleccionado
   * @param modelo  modelo donde se agrega el valor
   * @return void
   */
  seleccionarValorSelect2(valor: any, modelo, url: string = "", item: any[] = [], id:string = "" ) {
    if(valor){
      if (valor.hasOwnProperty("value")) {
        valor = valor.value
      }else{
        valor = valor;
      } 
    }

    if (typeof modelo == 'string'){
      this[modelo] = valor;
    }else{
      modelo.patchValue(valor);
    }
    if (url != "") {
      this.catalogoDependiente(url, item, valor);
    }
    if (id != "" && this.selected != valor) {
      setTimeout(() => {
        document.getElementById(id)?.click();
      }, 100);
    }
    this.selected = valor;
  }
  /**
   * Este método muestra los mensajes resultantes de los llamados de la api
   * @param cuentaAtras numero de segundo a esperar para que el mensaje desaparezca solo
   * @param posicion  array de posicion [vertical, horizontal]
   * @return void
   */
  mensaje(cuentaAtras: number = 6, posicion: any[] = ["bottom", "left"]): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: false,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };
    if (this.mensajeResponse.titulo == "")
      this.mensajeResponse.titulo = this.titulo;

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }

  /**
   * Este método muestra los mensajes resultantes de los llamados de la api
   * @param titulo Titulo del mensaje
   * @param texto  Texto a mostrar en el mensaje
   * @param mostrar  Bandera para mostrar el mensaje defalut true
   * @param clase  Color del mensaje ( success, warning, danger, info, alert)
   * @param tiempo  Tiempo en segundos para desaparecer el mensaje
   * @return void
 */
  mensaje_mostrar(titulo, texto, mostrar, clase, tiempo){
    this.mensajeResponse.titulo = titulo;
    this.mensajeResponse.texto = texto;
    this.mensajeResponse.mostrar = mostrar;
    this.mensajeResponse.clase = clase;
    this.mensaje(tiempo);
  }

  cambiar_empresa() {
    this.configuracion.empresa = this.dato.value.configuracion;
    localStorage.setItem("configuracion", JSON.stringify(this.configuracion));
  }
  cambiar_sucursal() {
    this.configuracion.sucursal = this.dato.value.configuracion;
    localStorage.setItem("configuracion", JSON.stringify(this.configuracion));
  }

  iniciar_derecha(p) {
    this.derecha[p] = [];
  }
  iniciar_izquierda(p) {
    this.izquierda[p] = [];
  }

  imprimir() {

    if (document.getElementById("imprimir_local"))
      document.getElementById("imprimir_local")?.click();
    else{
      let html = "";
      if (document.getElementById("imprimir")) {
        html = document.getElementById("imprimir").innerHTML;
      } 
      html =
        '<html lang="es">' +
        " <head>" +
        ' <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />' +
        ' <meta name="charset" content="UTF-8">' +
        ' <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">' +
        ' <meta name="apple-mobile-web-app-capable" content="yes">' +
        ' <title>PDF</title> <meta name="viewport" content="initial-scale=1" />' +
        ' <link rel="stylesheet" href="https://bulma.io/css/bulma-docs.css?v=201712202318">' +
        " <style>html { font-size: .8em; font-weight: 900; color: #000000;} body {font-size: .8em; font-weight: 900; color: #000000;} select::-ms-expand {display: none;} table{font-size: .7em}" +
        ".figure-border { border-radius: 5px; box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);" +
        " min-height: 159px;} .hr{ margin: .85rem 0 !important;} .sellos_sat{ font-size:8.5pt !important;}" +
        ".columns{margin:0px !important} .column{padding: .2em !important}</style>" +
        " </head>" +
        " <body>" +
        html +
        " </body>" +
        " </html>";
      let iframe = document.createElement("iframe");
      iframe.setAttribute("id", "printf");

      document.body.appendChild(iframe);

      const mywindow: HTMLIFrameElement = document.getElementById('printf') as HTMLIFrameElement;
      mywindow.contentWindow.document.write(html);
      setTimeout(() => {
        //  lanzar la sentencia imprimir
        mywindow.contentWindow.print();
      }, 500);
      setTimeout(() => {
        //  remover el contenedor de impresión
        document.body.removeChild(iframe);
      }, 2000);
    }
  }

  guardar_lista_colas() {
    if (localStorage.getItem(this.URL)) {
      let cola = localStorage.getItem(this.URL);
      cola = cola.substring(1, cola.length - 1);
      if (cola.length > 1) {
        cola = cola + "," + JSON.stringify(this.dato.getRawValue());
      } else {
        cola = JSON.stringify(this.dato.getRawValue());
      }
      cola = "[" + cola + "]";
      localStorage.setItem(this.URL, cola);
    } else {
      let cola = JSON.stringify([this.dato.getRawValue()]);
      localStorage.setItem(this.URL, cola);
    }

    this[this.URL] = JSON.parse(localStorage.getItem(this.URL));
    this.reset_form();
  }

  cargar_lista_colas(index, id) {
    this.reset_form();
    this.dato.patchValue(
      this.cargarDatosRecursivoObject(this[this.URL][index], this.dato)
    );
    if (this.dato.controls.cola) {
      this.dato.controls.cola.patchValue(index);
    }
    this.cancelarModal(id);
  }

  quitar_lista_colas(index, id) {
    this[this.URL] = JSON.parse(localStorage.getItem(this.URL));
    this[this.URL].splice(index, 1);
    localStorage.setItem(this.URL, JSON.stringify(this[this.URL]));
    this.cancelarModal(id);
  }

  quitar_elemento_cola() {
    if (this.dato.controls.cola) {
      if (this[this.URL]){
        this[this.URL].splice(this.dato.controls.cola.value, 1);
        localStorage.setItem(this.URL, JSON.stringify(this[this.URL]));
      }
    }
  }

  mostrar_mensaje(titulo, mensaje, clase) {
    this.mensajeResponse.titulo = titulo;
    this.mensajeResponse.texto = mensaje;
    this.mensajeResponse.mostrar = true;
    this.mensajeResponse.clase = clase;
    this.mensaje(3);
  }

  imprimeTicket(item) {
    let paginaAlto = 350;
    if(!item.hasOwnProperty("movimientos")){
      item.movimientos = item;
    }

    paginaAlto = paginaAlto + (item.movimientos.movimientos_articulos.length * 10);

    let doc = new jsPDF("p", "mm", [200, paginaAlto]);
    let imgData = 'data:image/jpeg;base64,' + item.movimientos.barcode;
    //Header
    doc.setFontSize(9);
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.empresa.nombre, 35, 6, {align:"center"});

    doc.setFontSize(8);
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.direccion.split(",")[0],35, 10,  {align:"center"});
    doc.text(this.configuracion.sucursal.direccion.split(",")[1],35, 13,  {align:"center"});
    doc.text("RFC: " + this.configuracion.sucursal.facturacion.rfc,35, 18,  {align:"center"});

    doc.setFont("courier", "", "bold");
    doc.setFontSize(6);
    doc.text( '--------------------------------------------------',35, 23, {align:'center'});

    doc.setFontSize(7);
    doc.text('Campus: ' + this.configuracion.sucursal.nombre,35, 27,  {align:'center'});
    doc.setFont("courier", "", "bold");
    doc.text('Telefono',35, 30,  {align:'center'});
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.telefono,35, 33,  {align:"center"});
    doc.setFont("courier", "", "bold");
    doc.text('Correo', 35, 36, {align:'center'});
    doc.setFont("courier", "", "bold");
    doc.text(this.configuracion.sucursal.correo,35, 39,  {align:"center"});

    doc.setFontSize(6);
    doc.text('--------------------------------------------------',35, 43,  {align:'center'});
    doc.setFontSize(8);
    doc.setFontSize(7);
    doc.text('CÓDIGO: ' + item.movimientos.codigo, 67, 48, {align:'right'});
    doc.text('FECHA: ' + item.created_at,67, 52,  {align:'right'});
    doc.text("CLIENTE: " + item.movimientos.personas.nombre_completo,69, 56,  {align:"right"});

    doc.setFontSize(6);
    doc.text('--------------------------------------------------',35, 60,  {align:'center'});

    doc.setFontSize(6);
    doc.setFont("courier", "", "bold");
    doc.text('DETALLE',35, 66,  {align:'center'});
    doc.text('CANT.',5, 71,  {align:'left'});
    doc.text('PRECIO',14, 71,  {align:'left'});
    doc.text('DESCUENTO',32, 71,  {align:'left'});
    doc.text('IMPORTE',50, 71,  {align:'left'});

    doc.setFont("courier", "", "bold");
    doc.setFontSize(6);
    let lineaY = 73;
    for (let k in item.movimientos.movimientos_articulos) {
      doc.text("ARTICULO: ",5, lineaY,  {align:"left"});
      doc.text(item.movimientos.movimientos_articulos[k].articulos.nombre,18, lineaY,  {align:'left'});
      lineaY = lineaY + 3;
      doc.text(item.movimientos.movimientos_articulos[k].cantidad,5, lineaY,  {align:'left'});
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].precio_unitario),14, lineaY,  {align:'left'});
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].descuento),45, lineaY,  {align:'right'});
      doc.text(this.convertirMoneda(item.movimientos.movimientos_articulos[k].precio_con_descuentos),64, lineaY,  {align:'right'});

      lineaY = lineaY + 2;
      doc.text("--------------------------------------------------",35, lineaY,  {align:"center"});

      lineaY = lineaY + 3;
    }

    lineaY = (lineaY - 3) + 5;

    doc.setFontSize(6);
    doc.setFont("courier", "", "bold");
    doc.text('SUBTOTAL: ' + this.convertirMoneda(item.movimientos.subtotal),67, lineaY,  {align:'right'});
    lineaY = lineaY + 4;
    doc.text('DESCUENTO: ' + this.convertirMoneda(item.movimientos.descuento),67, lineaY,  {align:'right'});
    lineaY = lineaY + 4;
    doc.text('TOTAL: ' + this.convertirMoneda(item.movimientos.total),67, lineaY,  {align:'right'});
    lineaY = lineaY + 4;
    doc.text(item.movimientos.pagos[0].tipos_formas_pagos.nombre.toUpperCase() + ": " + this.convertirMoneda(item.movimientos.pagos[0].paga_con),67, lineaY,  {align:'right'});
    doc.setFont("courier", "", "bold");
    lineaY = lineaY + 4;
    doc.text("CAMBIO: " + this.convertirMoneda(item.movimientos.pagos[0].cambio),67, lineaY,  {align:'right'});
    doc.setFont("courier", "", "bold");
    lineaY = lineaY + 4;
    doc.text(item.movimientos.pagos[0].tipos_metodos_pagos.nombre.toUpperCase(),67, lineaY,  {align:'right'});

    doc.setFontSize(6);
    lineaY = lineaY + 5;
    doc.text('--------------------------------------------------',35, lineaY, {align: 'center'});
    doc.setFontSize(6);
    lineaY = lineaY + 4;
    if (this.configuracion.sucursal.imprimir_usuario_ticket) {
      doc.text('Atendió: ' + item.movimientos.usuarios.nombre,35, lineaY,  {align:'center'});
      lineaY = lineaY + 4;
    }
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");

    doc.text(this.configuracion.sucursal.mensaje ? this.configuracion.sucursal.mensaje : 'Gracias por su pago', 35, lineaY, {align:"center"});
    lineaY = lineaY + 2;
    doc.addImage(imgData, 'JPEG', 15, lineaY, 40, 3, 'center');

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'ticket.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  imprimeFactura(json:any, logo, personas_rfcs_seleccionado = null) {

    let doc = new jsPDF('portrait', 'mm', 'letter');

    let linea = 10;

    doc.setFont("courier");
    doc.setFontSize(9);
    doc.setFont("courier", "", "bold");
    doc.text(json.Emisor.Nombre.toUpperCase(),209, linea,  {align:'right'});

    linea += 5;

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);

    // folio fiscal y emisor
    doc.roundedRect(10, linea, 30, 32, 2, 2, 'FD');
    doc.line(13, linea + 3, 37, linea + 3);

    doc.roundedRect(41, linea, 103, 32, 2, 2, 'FD');
    doc.line(44, linea + 3, 141, linea + 3);

    doc.roundedRect(145, linea, 65, 32, 2, 2, 'FD');
    doc.line(148, linea + 3, 207, linea + 3);

    doc.setFont("courier");
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");

    if (logo && logo != '')
      doc.addImage(logo, "PNG", 12, linea + 5, 26, 26, "", "FAST");

    doc.text('Folio fiscal: ',44, linea + 8,  {align:'left'});
    doc.text('No. de serie del CSD: ',44, linea + 13,  {align:'left'});
    doc.text('No. de serie del certificado SAT: ',44, linea + 18,  {align:'left'});
    doc.text('Fecha y hora de emisión: ', 44, linea + 23, {align:'left'});
    doc.text('Fecha y hora de certificación: ', 44, linea + 28, {align:'left'});

    doc.text('Dirección: ', 148, linea + 8, {align:'left'});
    doc.text( 'R.F.C.: ',148, linea + 13, {align:'left'});
    doc.text('Lugar de expedición: ',148, linea + 18,  {align:'left'});
    doc.text('Régimen fiscal: ',148, linea + 23,  {align:'left'});
    doc.text('Tipo de comprobante: ',148, linea + 28,  {align:'left'});

    doc.setFont("courier", "", "normal");

    doc.text( json.Complemento.TimbreFiscalDigital.UUID,70.5, linea + 8, {align:'left'});
    doc.text( json.NoCertificado,94, linea + 13, {align:'left'});
    doc.text(json.Complemento.TimbreFiscalDigital.NoCertificadoSAT,94, linea + 18,  {align:'left'});
    doc.text(json.Fecha,94, linea + 23,  {align:'left'});
    doc.text(json.Complemento.TimbreFiscalDigital.FechaTimbrado,95.5, linea + 28,  {align:'left'});

    doc.setFont("courier", "", "bold");

    doc.setFont("courier", "", "normal");

    doc.text(this.configuracion.sucursal.direccion.split(',')[0],163, linea + 8,  {align:'left'});
    doc.text(json.Emisor.Rfc,162, linea + 13,  {align:'left'});
    doc.text(json.LugarExpedicion,182, linea + 18,  {align:'left'});
    doc.text(json.Emisor.RegimenFiscal,182, linea + 23,  {align:'left'});
    doc.text(json.TipoDeComprobante, 182, linea + 28, {align:'left'});

    linea += 33;

    // Receptor y uso
    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);

    doc.roundedRect(10, linea, 134, 17, 2, 2, 'FD');
    doc.line(13, linea + 3, 141, linea + 3);
    doc.roundedRect(145, linea, 65, 17, 2, 2, 'FD');
    doc.line(148, linea + 3, 207, linea + 3);

    doc.setFont("courier");
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");

    doc.text('Receptor: ',13, linea + 6,  {align:'left'});
    doc.text('R.F.C.: ', 13, linea + 11, {align:'left'});
    doc.text('Domicilio: ', 13, linea + 16, {align:'left'});

    doc.text('Uso CFDI: ',148, linea + 8,  {align:'left'});
    doc.text('Folio y serie: ',148, linea + 13,  {align:'left'});

    doc.setFont("courier", "", "normal");

    doc.text(json.Receptor.Nombre.toUpperCase(),28, linea + 6,  {align:'left'});
    doc.text(json.Receptor.Rfc,28, linea + 11,  {align:'left'});

    let direccion = '';
    if(personas_rfcs_seleccionado){
    direccion = personas_rfcs_seleccionado.calle + " #" + 
        personas_rfcs_seleccionado.numero_exterior + ", " + 
        (personas_rfcs_seleccionado.numero_interior ? " INT. " + personas_rfcs_seleccionado.numero_interior + "," : "")  + 
        personas_rfcs_seleccionado.colonia  + ", CP:" + 
        personas_rfcs_seleccionado.codigo_postal + ", " + 
        personas_rfcs_seleccionado.municipios.nombre + ", " +  
        personas_rfcs_seleccionado.estados.nombre;
    }

    var splitTitle = doc.splitTextToSize(direccion, 112);
    doc.text(splitTitle, 28, linea + 16, {maxWidth: 112, align: "justify"});

    doc.text(json.Receptor.UsoCFDI,170, linea + 8,  {align:'left'});
    doc.text(json.Folio + " " + json.Serie,170, linea + 13,  {align:'left'});

    linea += 18;

    // Detalles de alumno
    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("courier", "", "bold");

    if (json.Conceptos.Concepto.length > 0) {
      if (json.Conceptos.Concepto[0].ComplementoConcepto != undefined) {
        doc.roundedRect(10, linea, 200, 18, 2, 2, 'FD');
        doc.line(13, linea + 3, 207, linea + 3);

        linea += 7;

        doc.text('IEDU Versión',13, linea,  {align:'left'});
        doc.text('Alumno',38, linea,  {align:'left'});
        doc.text('CURP',105, linea,  {align:'left'});
        doc.text('Nivel',140, linea,  {align:'left'});
        doc.text('RVOE', 173, linea, {align:'left'});

        doc.line(13, linea + 2, 207, linea + 2);

        linea += 8;
        doc.setFont("courier", "", "normal");

        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.version,13, linea,  {align:'left'});
        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.nombreAlumno,38, linea,  {align:'left'});
        doc.text( json.Conceptos.Concepto[0].ComplementoConcepto.CURP ?? '',105, linea, {align:'left'});
        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.nivelEducativo, 140, linea, {align:'left'});
        doc.text(json.Conceptos.Concepto[0].ComplementoConcepto.autRVOE,173, linea, {align: 'left'});

        linea += 4;
      }
    }

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("courier", "", "bold");

    // Detalles de productos
    let tam_art = (json.Conceptos.Concepto.length + 1) * 6.2;
    json.Conceptos.Concepto.forEach(concepto => {
      tam_art += ((concepto.Descripcion.length / 44) * 1.2);
    });

    tam_art += 6;
    let linea_temp = linea + 1;
    if ((linea + tam_art) > 270)
      tam_art = 200;

    doc.roundedRect(10, linea, 200, tam_art, 2, 2, 'FD');
    doc.line(13, linea + 3, 207, linea + 3);

    linea += 8;
    doc.setFontSize(6);
    doc.setFont("courier", "", "bold");

    doc.text('Prod/Serv',13, linea,  {align:'left'});
    doc.text( 'No.Id.',27, linea, {align:'left'});
    doc.text('Cant.',36, linea,  {align:'left'});
    doc.text('Unidad',44, linea,  {align:'left'});
    doc.text('Descripción', 65, linea, {align:'left'});
    doc.text('Precio',124, linea,  {align:'left'});
    doc.text('Descuento', 141, linea, {align:'left'});
    doc.text('Impuesto',158, linea,  {align:'left'});
    doc.text('Importe', 188, linea, {align:'left'});

    doc.line(13, linea + 3, 207, linea + 3);

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("courier", "", "normal");

    json.Conceptos.Concepto.forEach((concepto, numero) => {
      linea += 6;
      doc.text(concepto.ClaveProdServ,13, linea,  {align:'left'});
      doc.text(concepto.NoIdentificacion,27, linea,  {align:'left'});
      doc.text(concepto.Cantidad, 36, linea, {align:'left'});
      if (concepto.Unidad.indexOf(concepto.ClaveUnidad) == -1) {
        doc.text(concepto.ClaveUnidad,44, linea,  {align:'left'});
        doc.setFontSize(3.5);
        doc.text(concepto.Unidad,48, linea,  {align:'left'});
      } else {
        doc.setFontSize(4);
        doc.text(concepto.Unidad,44, linea,  {align:'left'});
      }
      doc.setFontSize(6);
      let descripcion = []; let cadena = ''; let index = 0;
      if (concepto.Descripcion.length <= 44) {
        descripcion.push(concepto.Descripcion);
      } else {
        for (let i = 0; i < concepto.Descripcion.length; i++) {
          cadena += concepto.Descripcion.charAt(i);
          if (index == 44) {
            descripcion.push(cadena);
            cadena = '';
            index = 0;
          }
          index++;
        }
        if (cadena != '') {
          descripcion.push(cadena);
        }
        linea = linea - 3;
        linea += Math.trunc((concepto.Descripcion.length / 44) * 3);
      }
      let indice = 0;
      descripcion.forEach(texto => {
        doc.text( texto,65, linea + indice, {align:'left'});
        if (descripcion.length > 1) {
          indice += 3;
        }
      });

      doc.setFontSize(5);

      doc.text(this.convertirMoneda(concepto.ValorUnitario), 124, linea, {align:'left'});
      doc.text(this.convertirMoneda(concepto.Descuento),141, linea,  {align:'left'});

      doc.setFontSize(3.5);
      if(concepto.Impuestos){
        if (concepto.Impuestos.Traslados)
        if (concepto.Impuestos.Traslados.length > 0) {
          doc.text("Traslados",158, linea - 1,  {align:'left'});
          let linea_tr = 0;
          concepto.Impuestos.Traslados.forEach(tr => {
            linea_tr += 2;
            let factor = tr.Traslado.TipoFactor == "Tasa" ? (tr.Traslado.TasaOCuota * 100) + "%" : tr.Traslado.TasaOCuota;
            let impuesto = "" + tr.Traslado.Impuesto + "(" + factor + "): " + this.convertirMoneda(tr.Traslado.Importe);
            doc.text(impuesto, 158, (linea - 1) + linea_tr, {align:'left'});
          });
        }
        if (concepto.Impuestos.Retenciones)
        if (concepto.Impuestos.Retenciones.length > 0) {
          doc.text("Retenciones",173, linea - 1,  {align:'left'});
          let linea_re = 0;
          concepto.Impuestos.Retenciones.forEach(re => {
            linea_re += 2;
            let factor = re.Retencion.TipoFactor == "Tasa" ? (re.Retencion.TasaOCuota * 100) + "%" : re.Retencion.TasaOCuota;
            let impuesto = "" + re.Retencion.Impuesto + "(" + factor + "): " + this.convertirMoneda(re.Retencion.Importe);
            doc.text(impuesto,173, (linea - 1) + linea_re,  {align:'left'});
          });
        }
      }
      doc.setFontSize(5);

      doc.text(this.convertirMoneda(concepto.Importe), 188, linea, {align:'left'});

      doc.setFontSize(6);
      linea += 1;
      doc.line(13, linea + 3, 207, linea + 3);

      if (linea > 250) {
        linea = 10;
        doc.addPage();

        tam_art = ((json.Conceptos.Concepto.length - numero) + 1) * 6.2;
        json.Conceptos.Concepto.forEach((concepto, num) => {
          if (num > numero)
            tam_art += ((concepto.Descripcion.length / 44) * 1.2);
        });

        tam_art += 6;
        linea_temp = linea + 1;
        if ((linea + tam_art) > 270)
          tam_art = 200;

        doc.setLineWidth(0.1);
        doc.setDrawColor(1, 1, 1);
        doc.setFillColor(255, 255, 255);
        doc.setFont("courier", "", "bold");

        doc.roundedRect(10, linea, 200, tam_art, 2, 2, 'FD');
        doc.line(13, linea + 3, 207, linea + 3);

        linea += 8;
        doc.setFontSize(6);
        doc.setFont("courier", "", "bold");

        doc.text('Prod/Serv', 13, linea, {align:'left'});
        doc.text('No.Id.',27, linea,  {align:'left'});
        doc.text('Cant.',36, linea,  {align:'left'});
        doc.text('Unidad',44, linea,  {align:'left'});
        doc.text('Descripción',65, linea,  {align:'left'});
        doc.text('Precio',124, linea,  {align:'left'});
        doc.text('Descuento',141, linea,  {align:'left'});
        doc.text('Impuesto',158, linea,  {align:'left'});
        doc.text('Importe',188, linea,  {align:'left'});

        doc.line(13, linea + 3, 202, linea + 3);

        doc.setLineWidth(0.1);
        doc.setDrawColor(1, 1, 1);
        doc.setFillColor(255, 255, 255);
        doc.setFont("courier", "", "normal");
      }

    });

    linea = linea_temp + tam_art;
    if ((linea + 30) > 270) {
      linea = 10;
      doc.addPage();
    }

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);

    doc.setFont("courier");
    doc.setFontSize(7);
    doc.setFont("courier", "", "bold");

    // Totales

    doc.roundedRect(10, linea, 134, 29, 2, 2, 'FD');
    doc.line(13, linea + 3, 141, linea + 3);
    doc.roundedRect(145, linea, 65, 29, 2, 2, 'FD');
    doc.line(148, linea + 3, 207, linea + 3);

    doc.text('Total con letra: ',13, linea + 8,  {align:'left'});
    doc.line(13, linea + 12, 141, linea + 12);
    doc.text('Moneda: ', 13, linea + 20, {align:'left'});
    doc.text('Forma de pago: ', 13, linea + 25, {align:'left'});

    doc.text('Método de pago: ', 78, linea + 20, {align:'left'});
    doc.text('Condiciones de pago: ',78, linea + 25,  {align:'left'});

    doc.text('Subtotal: ', 148, linea + 8, {align:'left'});
    doc.text('Descuento: ',148, linea + 12,  {align:'left'});


    doc.setFont("courier", "", "normal");

    doc.text(this.convertirImporteLetra(json.Total),38, linea + 8,  {align:'left'});
    doc.text(json.Moneda,35, linea + 20,  {align:'left'});
    doc.text( json.FormaPago,35, linea + 25, {align:'left'});

    doc.text(json.MetodoPago,115, linea + 20,  {align:'left'});
    doc.text(json.CondicionesDePago, 115, linea + 25, {align:'left'});

    doc.text(this.convertirMoneda(json.SubTotal), 165, linea + 8, {align:'left'});
    doc.text(this.convertirMoneda(json.Descuento),165, linea + 12,  {align:'left'});

    doc.setFontSize(5);
    let tem_linea = linea + 16;
    let linea_ret = 0;
    let linea_tra = 0;
    if(json.Impuestos){
      
      if (json.Impuestos.Traslados)
      if (json.Impuestos.Traslados.length > 0) {
        doc.text("Traslados",148, tem_linea - 1,  {align:'left'});
        let linea_tr = 0;
        json.Impuestos.Traslados.forEach(tr => {
          linea_tr += 2;
          let factor = tr.Traslado.TipoFactor == "Tasa" ? (tr.Traslado.TasaOCuota * 100) + "%" : tr.Traslado.TasaOCuota;
          let impuesto = "" + tr.Traslado.Impuesto + "(" + factor + "): " + this.convertirMoneda(tr.Traslado.Importe);
          doc.text(impuesto,148, (tem_linea - 1) + linea_tr,  {align:'left'});
          linea_tra++;
        });
      }
      if (json.Impuestos.Retenciones)
      if (json.Impuestos.Retenciones.length > 0) {
        doc.text("Retenciones",175, tem_linea - 1,  {align:'left'});
        let linea_re = 0;
        json.Impuestos.Retenciones.forEach(re => {
          linea_re += 2;
          let factor = re.Retencion.TipoFactor == "Tasa" ? (re.Retencion.TasaOCuota * 100) + "%" : re.Retencion.TasaOCuota;
          let impuesto = "" + re.Retencion.Impuesto + "(" + factor + "): " + this.convertirMoneda(re.Retencion.Importe);
          doc.text(impuesto,175, (tem_linea - 1) + linea_re,  {align:'left'});
          linea_ret ++;
        });
      }
    }
    let linea_t = linea + ((linea_ret > linea_tra ? linea_ret : linea_tra) * 2) + 4;
    doc.setFontSize(10);

    doc.setFont("courier", "", "bold");
    doc.text('Total: ',148, linea_t + 17,  {align:'left'});
    doc.setFont("courier", "", "normal");
    doc.text(this.convertirMoneda(json.Total),165, linea_t + 17,  {align:'left'});

    doc.setFontSize(6);

    linea += 30;

    if ((linea + 35) > 270) {
      linea = 10;
      doc.addPage();
    }

    doc.setLineWidth(0.1);
    doc.setDrawColor(1, 1, 1);
    doc.setFillColor(255, 255, 255);
    doc.setFont("courier", "", "bold");

    // QR y sellos
    doc.setFontSize(7);

    doc.roundedRect(10, linea, 30, 35, 2, 2, 'FD');
    doc.line(13, linea + 3, 37, linea + 3);
    doc.roundedRect(41, linea, 169, 35, 2, 2, 'FD');
    doc.line(44, linea + 3, 207, linea + 3);

    doc.text('Sello digital del CFDI: ',44, linea + 8,  {align:'left'});
    doc.text('Sello digital del SAT: ',44, linea + 16,  {align:'left'});
    doc.text('Cadena original del complemento de certificación del SAT: ',44, linea + 24,  {align:'left'});

    doc.setFont("courier", "", "normal");

    if (json.Complemento.TimbreFiscalDigital.qr && json.Complemento.TimbreFiscalDigital.qr != '')
      doc.addImage(json.Complemento.TimbreFiscalDigital.qr, "PNG", 10.5, linea + 5, 29, 29, "", "FAST");

    let Sello = json.Complemento.TimbreFiscalDigital.SelloCFD;
    let SelloCFD = [];
    SelloCFD[0] = Sello.substr(0, 134);
    SelloCFD[1] = Sello.substr(134, 170);
    SelloCFD[2] = Sello.substr(304, Sello.length);

    let SAT = json.Complemento.TimbreFiscalDigital.SelloSAT;
    let SelloSAT = [];
    SelloSAT[0] = SAT.substr(0, 134);
    SelloSAT[1] = SAT.substr(134, 170);
    SelloSAT[2] = SAT.substr(304, Sello.length);

    let Original = json.Complemento.TimbreFiscalDigital.CadenaOriginal;
    let CadenaOriginal = [];
    CadenaOriginal[0] = Original.substr(0, 81);
    CadenaOriginal[1] = Original.substr(81, 170);
    CadenaOriginal[2] = Original.substr(251, 170);
    CadenaOriginal[3] = Original.substr(421, Original.length);

    doc.setFontSize(4.5);

    doc.text( SelloCFD[0], 78, linea + 8,{align:'left'});
    doc.text(SelloCFD[1],44, linea + 10,  {align:'left'});
    doc.text(SelloCFD[2], 44, linea + 12, {align:'left'});

    doc.text(SelloSAT[0], 78, linea + 16, {align:'left'});
    doc.text(SelloSAT[1],44, linea + 18,  {align:'left'});
    doc.text(SelloSAT[2],44, linea + 20,  {align:'left'});

    doc.text(CadenaOriginal[0],129, linea + 24,  {align:'left'});
    doc.text(CadenaOriginal[1],44, linea + 26,  {align:'left'});
    doc.text(CadenaOriginal[2],44, linea + 28,  {align:'left'});
    doc.text(CadenaOriginal[3],44, linea + 30,  {align:'left'});

    doc.setFont("courier", "", "normal");
    doc.text('Este documento es una representación impresa de un CFDI ' + json.Version,105, 273,  {align:'center'});

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'f.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  convertirMoneda(importe) {
    return (new CurrencyPipe('en')).transform(importe, this.configuracion.sucursal.moneda, true);
  }
  convertirImporteLetra(importe){
    return (new NumeroLetraPipe()).transform(importe, this.configuracion.sucursal.moneda);
  }
}
